import { BaseModel } from '../base-model';

export interface IDemandProposalListing {}
export class DemandProposalListing extends BaseModel<IDemandProposalListing> implements IDemandProposalListing {
  /**
   *
   */
  constructor(option?: DemandProposalListing) {
    super(option);
    
  }
}